
class dybFormController

    ### @ngInject ###
    constructor: (@$q, @$element, @$scope, @$attrs, $parse, $transclude) ->

        @scope = @$scope
        @ngForm = @$element.controller('form')

        @controls = {}
        @formData = {}
        @isOpen = false
        @pickClass(false, "open", "closed")
        @$element.attr('novalidate', 'novalidate')

        if @$attrs.startOpen?
            @isOpen = $parse(@$attrs.startOpen)(@scope.$parent)

        @scope.$watch('open', (v) => @watchOpen(v))
        @scope.$watch('editable', @watchEditable)

        if @$attrs.dybForm
            exp = $parse(@$attrs.dybForm)
            exp.assign(@scope.$parent, @)

        # $transclude (transcludeElement, transcludeScope) =>
        #     formName = @$attrs.dybForm or 'dybForm'
        #     transcludeScope[formName] = @
        #     transcludeScope.formData = @formData
        #     @$element.find("form-content").append(transcludeElement)

    Object.defineProperties @prototype,

        isOpen:
            get: -> !!@_isOpen
            set: (value) ->
                newState = !!value and @isEditable
                oldState = @_isOpen
                if oldState != newState
                    if newState then @open() else @close()

        isEditable:
            get: -> @$scope.editable
            set: (value) -> @$scope.editable = !!value

    addControl: (control) ->
        @[control.name] = control
        @controls[control.name] = control
        return

    removeControl: (control) ->
        delete @controls[control.name]
        delete @[control.name]
        return

    getFormData: (control) -> @formData[control.name]
    setFormData: (control, value) -> @formData[control.name] = value

    controlNames: ->
        Object.keys(@controls)

    pickClass: (value, trueClass, falseClass) ->
        @$element.toggleClass(trueClass, !!value)
        @$element.toggleClass(falseClass, !value)
        undefined

    watchOpen: (value) =>
        @isOpen = value
        return

    watchEditable: (value) =>
        @pickClass(value, "editable", "locked")

    refreshFormData: ->
        control.refreshData() for own name, control of @controls
        @onRefresh()
        return

    open: =>
        if @isOpen then return @$q.reject('already open')
        openPromise = @$q.when(@onOpen(dybForm: @))
        openPromise.then =>
            @pickClass(true, "open", "closed")
            @refreshFormData()
            @scope.open = true
            @_isOpen = true
            @scope.$broadcast?('elastic:adjust')

    close: =>
        if not @isOpen then return @$q.reject("already closed")
        closePromise = @$q.when(@onClose(dybForm: @))
        closePromise.then =>
            @pickClass(false, "open", "closed")
            @refreshFormData()
            @scope.open = @_isOpen = false
            return @$q.when(@afterClose())

    save: ->
        @ngForm.$commitViewValue()

        context =
            data: angular.copy(@formData)
            ngForm: @ngForm
            dybForm: @

        return @$q.when(@onSave(context))

    saveSuccess: (result)->
        @close().then => @afterSave({result: result})

    saveError: ->


    toJSON: ->
        json =
            isOpen: @isOpen
            isEditable: @isEditable

        for name, control of @controls
            json[name] = control

        json

dybFormDirective = ->
    restrict: 'A'
    templateUrl: 'forms/form'
    require: 'form'
    transclude:
        extraButtons: '?extraButtons'
    scope:
        open: '=?formOpen'
        editable: '=?formEditable'

    controllerAs: 'ctrl'
    controller: dybFormController
    bindToController:
        onOpen: '&'
        onClose: '&'
        onSave: '&'
        onRefresh: '&'
        afterSave: '&'
        afterClose: '&'

    link: (scope, element) ->
        element.addClass('dyb-form')


module.directive("dybForm", dybFormDirective)
